import React, { createContext, useContext, useState } from 'react';
import { setLogoutHandler } from '../api/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [tokens, setTokens] = useState(() => {
    const savedTokens = localStorage.getItem('tokens');
    return savedTokens ? JSON.parse(savedTokens) : null;
  });

  const login = async (accessToken, refreshToken, userType) => {
    const newTokens = { access: accessToken, refresh: refreshToken };
    setTokens(newTokens);
    localStorage.setItem('tokens', JSON.stringify(newTokens));
    localStorage.setItem('authType', userType);
  };

  const logout = () => {
    setTokens(null);
    localStorage.removeItem('tokens');
    localStorage.removeItem('authType');
  };

  const getAuthType = () => {
    return localStorage.getItem('authType') || 'chowa';
  };

  const value = {
    tokens,
    login,
    logout,
    getAuthType,
    isAuthenticated: !!tokens,
  };

  React.useEffect(() => {
    setLogoutHandler(logout);
  }, []);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
